import React, { Component } from 'react';
import LocationSearchForm from '../organisms/LocationSearchForm';
import EnlisteeSearchForm from '../organisms/EnlisteeSearchForm';
import IconClose from '../atoms/IconClose';
import { Link } from 'react-router-dom';
import Tabs from '../atoms/Tabs';
import TabPane from '../atoms/TabPane';

class Search extends Component {

  render() {
    return (
      <div className="Search">
        <div className="buttons">
          <Link to="/"><IconClose/></Link>
        </div>
        <Tabs>
          <TabPane label="Locations">
            <LocationSearchForm/>
          </TabPane>
          <TabPane label="Enlistees">
            <EnlisteeSearchForm/>
          </TabPane>
        </Tabs>
      </div>
    )
  }
}

export default Search;